import React from "react";
import { withTheme } from "styled-components";
import { ToolsIcon } from "components/Icons/ToolsIcon/ToolsIcon";
import iconsList from "./iconsList";

export const missionCreatedAction = "mission-created_card-displayed";

const iconsMap = {
  [iconsList.tool]: ToolsIcon
};

const IconSelector = ({ iconName, ...props }) => {
  if (!iconName || !iconsMap[iconName]) {
    return null;
  }

  const Icon = iconsMap[iconName];
  return <Icon {...props} />;
};

export default withTheme(IconSelector);
